import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=fe928aec"
import script from "./loader.vue?vue&type=script&lang=ts"
export * from "./loader.vue?vue&type=script&lang=ts"
import style0 from "./loader.vue?vue&type=style&index=0&id=fe928aec&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe928aec')) {
      api.createRecord('fe928aec', component.options)
    } else {
      api.reload('fe928aec', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=fe928aec", function () {
      api.rerender('fe928aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/loading-spinner/loader.vue"
export default component.exports